// extracted by mini-css-extract-plugin
module.exports = {"deleteContainer":"delete-resource-type_deleteContainer__tCGil","error":"delete-resource-type_error__3clWj","actions":"delete-resource-type_actions__1UqoY"};